import { Link } from 'react-router-dom';

/**
 * The small print every screen that holds an account links to: the privacy
 * policy and terms both app stores ask for, and the account-deletion page
 * Google Play wants reachable from outside the app.
 */
export default function LegalLinks({ className = '', tone = 'muted' }) {
  const colour = tone === 'light' ? 'text-milk/70 hover:text-milk' : 'text-ink-muted hover:text-heading';
  return (
    <nav aria-label="Legal" className={`flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs ${className}`}>
      <Link to="/privacy" className={`inline-flex min-h-touch items-center underline-offset-2 hover:underline ${colour}`}>
        Privacy policy
      </Link>
      <Link to="/terms" className={`inline-flex min-h-touch items-center underline-offset-2 hover:underline ${colour}`}>
        Terms of use
      </Link>
      <Link to="/delete-account" className={`inline-flex min-h-touch items-center underline-offset-2 hover:underline ${colour}`}>
        Delete account
      </Link>
    </nav>
  );
}
